import { render, staticRenderFns } from "./Roteiro.vue?vue&type=template&id=aba0362c"
import script from "./Roteiro.vue?vue&type=script&lang=js"
export * from "./Roteiro.vue?vue&type=script&lang=js"
import style0 from "./Roteiro.vue?vue&type=style&index=0&id=aba0362c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports